/** @file zoomScale: the viewport's integer upscale (default from a 24 px world unit, wheel steps, 1..8). */

/** The upscale range of the viewport. */
const MIN = 1;
const MAX = 8;
/** One world unit should cover at least this many CSS pixels by default. */
const UNIT_CSS_PX = 24;

/**
 * `current === null`: the smallest scale with `pixelsPerUnit x scale / dpr >= 24` CSS px; else `current + step`.
 * Clamped to 1..8.
 */
export function zoomScale(current: number | null, step: number, pixelsPerUnit: number, dpr: number): number {
  const base = current ?? Math.ceil((UNIT_CSS_PX * dpr) / Math.max(1, pixelsPerUnit));
  return Math.min(MAX, Math.max(MIN, Math.round(base + step)));
}
